
<app-filters [itemList]="itemList" [itemFilters]="itemFilters" (onFiltersApplied)="filtersApplied($event)" (onDistributorInfoClicked)="distributorInfoClicked($event)">
</app-filters>
<!-- <ion-header class="filterHeader">
  <ion-toolbar>
    <ion-title class="filterHeader">
      <ion-label *ngIf="!options.type">{{'LABELS.FILTER_OUTSTANDING' | translate}} <product-item-header-multiple></product-item-header-multiple>
      </ion-label>
      <ion-label *ngIf="options.type">{{'LABELS.FILTER' | translate}} {{options.type}}</ion-label> -->
    <!--</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="filterContentContainer">
    <div class="filterContent">
      <app-filters [itemList]="itemList" [itemFilters]="itemFilters" (onFiltersApplied)="filtersApplied($event)" (onDistributorInfoClicked)="distributorInfoClicked($event)">
      </app-filters>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-row>
    <ion-col class="ion-text-right">
      <ion-button class="frpBtn defaultBtn" (click)="resetFilters()">{{'LABELS.RESET' | translate}}</ion-button>
    </ion-col>
    <ion-col class="ion-text-left" *ngIf="!filtersSelected">
      <ion-button class="frpBtn defaultBtn" (click)="dismiss()" strong>{{'LABELS.CLOSE' | translate}}</ion-button>
    </ion-col>
    <ion-col class="ion-text-left" *ngIf="filtersSelected">
      <ion-button class="frpBtn defaultBtn" (click)="dismiss()" strong>{{'LABELS.SELECT' | translate}}</ion-button>
    </ion-col>
  </ion-row>
</ion-footer> -->
